Number.prototype.number_format = function(n, c,s) {
    var x =3;
    /**
    https://stackoverflow.com/questions/149055/how-can-i-format-numbers-as-currency-string-in-javascript
    * Number.prototype.format(n, x, s, c)
    *
    * @param integer n: length of decimal
    * @param integer x: length of whole part
    * @param mixed   s: sections delimiter
    * @param mixed   c: decimal delimiter
    */
    var re = '\\d(?=(\\d{' + (x || 3) + '})+' + (n > 0 ? '\\D' : '$') + ')',
    num = this.toFixed(Math.max(0, ~~n));

    return (c ? num.replace('.', c) : num).replace(new RegExp(re, 'g'), '$&' + (s || ','));
};